import { Title, Body, Micro } from "@vds3/typography";
import React from "react";
import { useSelector } from "react-redux";
import { MarginSpacerM, MarginSpacerS } from "../../../../Checkout/styleTag";

 const DueMonthlyPrint = (props) => {
    const getFloatCartResponse = useSelector((state) => state.CustomizeOrder.getFloatCartResponse);
    const servicesInCart = useSelector((state) => state.CustomizeOrder.servicesInCart)
    const installments = useSelector((state) => state.CheckoutPage.installments)

    const { headerInfo, BlueJeanInfo, dataInfo, phoneInfo, tvInfo, subTotals, otherServices, equipmentAndOnetimeCharges, equipmentAndOnetimeChargesTotal    , taxAndOtherCharges, subTotalequipmentAndOnetimeCharges } = getFloatCartResponse?.planDetails;         
    return (
        <div>
            {servicesInCart!="BDV"?<InternetSection {...getFloatCartResponse?.planDetails} showAutoPayTax={props?.showAutoPayTax || false} installments={installments || {}} autoPayCartInfo={props?.autoPayCartInfo || ""}/>:<></>}
            {getFloatCartResponse?.planDetails?.phoneInfo?<BDVInfo phoneInfo={phoneInfo}/>:<></>}
            <TVPlan tvInfo={tvInfo}/>
            <OtherService otherServices={otherServices} tvInfo={tvInfo}/>
            <EquipmentCharges {...getFloatCartResponse?.planDetails}/>
            <TaxAndOtherChanges taxAndOtherCharges={taxAndOtherCharges} headerInfo={headerInfo}/>
        </div>
    )
}

const InternetSection = ({ dataInfo,subTotals,offerInfo,showAutoPayTax,installments,autoPayCartInfo}) => {
    return (
        <>
            <Micro color="#6F7171">Internet service</Micro>
            <CommonSection left={"Estimated monthly charges."} right={" "} />
            <MarginSpacerM/>
            <Micro color="#6F7171">Internet Plan</Micro>
            <CommonSection left={dataInfo?.['planName']} right={dataInfo?.['planPrice']} />
            <MarginSpacerM />
            {showAutoPayTax && autoPayCartInfo && autoPayCartInfo !== "fios.autoPayCartInfo" && installments?.autoPay===true && installments?.paperFreeBilling===true?<>
            <span dangerouslySetInnerHTML={{__html:autoPayCartInfo}}></span>
            <MarginSpacerM/>
            </>:<></>}
            {offerInfo && offerInfo?.length>0?<>
            <Body size="large">{(offerInfo?.[0]?.['planName'])??""}</Body>
            <Body size="large" bold>{(offerInfo?.[1]?.['planName'])??""}</Body>
            <MarginSpacerM/></>:<></>}
            <CommonSection left={"Subtotal internet Service"} right={subTotals?.['services']?.['price'] || ''} />
            <MarginSpacerM/>
        </>
    )
}
const BDVInfo = ({phoneInfo})=>{
    return(
        <>
            <Micro color="#6F7171">Business Digital Voice</Micro>
            <CommonSection left={phoneInfo?.['noOfLines']+" Lines"} right={" "} />
            {(phoneInfo?.['lines'] && phoneInfo?.['lines'].length) ? 
            phoneInfo['lines'].map(data=>(
            <CommonSection left={data?.['TN']+' - '+data?.['planName']} right={data?.['total']} />
            ))
            : <></>}
            {(phoneInfo?.['phoneServices'] && phoneInfo?.['phoneServices'].length) ?
            phoneInfo['phoneServices'].map(data=>(
            <CommonSection left={data['Name']} right={data?.['Rc']} />
            ))
            : <></>}
            <MarginSpacerM/>
        </>
    )
}

const TVPlan = ({tvInfo})=>{
    return(
        <>
        {tvInfo?<>
        <Micro color="#6F7171">TV Plan</Micro>
        <CommonSection left={tvInfo?.['planName']} right={tvInfo?.['planPrice']} />
        </>:<></>}
        </>
    )
}

const EquipmentCharges = ({equipmentAndOnetimeChargesTotal,equipmentAndOnetimeCharges,headerInfo})=>{
    return(
        <>
        <CommonSection left={"Total monthly charges"} right={headerInfo?.['Price']} bold/>
        <div style={{marginTop:'2rem'}}>
        <Micro color="#6F7171">Equipment and one-time charges</Micro>
        <CommonSection left="Equipment, activation and other fees can be billed over installments. You can make installment updates during checkout." right=" "/>
         <MarginSpacerM/>
         {(equipmentAndOnetimeCharges&&equipmentAndOnetimeCharges.length) ?
         equipmentAndOnetimeCharges.map(equip=>(
            <CommonSection left={equip?.offerName} right={equip?.price} microText={equip?.installmentOption}/>
         ))
         : <></>}
         <MarginSpacerM/>
        <CommonSection left={equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges?.Name} right={equipmentAndOnetimeChargesTotal?.subTotalequipmentAndOnetimeCharges?.price} bold/>
        <MarginSpacerM/>
        </div>
        </>
    )
}

const OtherService = ({ otherServices,tvInfo }) => {
    return (
        <div style={{marginTop:'1rem'}}>
            <Micro color="#6F7171">Other Service</Micro>
            {otherServices && otherServices.length ?
                otherServices.map(data => (
                        <CommonSection left={data['Product']} right={data['price']} />
                ))
                : <></>}
            {(tvInfo&&tvInfo['tvServices']&&tvInfo['tvServices'].length) ?
            tvInfo['tvServices'].map(data=>(
                <CommonSection left={data['prdName']} right={data['Price']} />
            ))
            : <></>}
            {(tvInfo && tvInfo['MovieChannelsPack'] && tvInfo.MovieChannelsPack?.length)?<>
                <CommonSection left={'Movie Channels Pack'} right={tvInfo['MoviechannelsPackPrice']??""} />
			    {tvInfo.MovieChannelsPack.map((item, i) => 
                    <CommonSection left={`- ${item["channelName"]}`} right={"Included"} />
                    )}
			</>:<></>}
        </div>
    )
}

const TaxAndOtherChanges = ({taxAndOtherCharges})=>{
    const { taxAndotherCharges } = taxAndOtherCharges || {}
    return(
        <>
        <Micro color="#6F7171">Taxes and other charges</Micro>
        <CommonSection left="Estimated taxes and other Verizon charges" right=" "/>
        {(taxAndotherCharges&&taxAndotherCharges.length) ? 
        taxAndotherCharges.map(data=>(
            <CommonSection left={data['offerName']} right={data['wavied'] ? 'Fee waived' : data['price']} microText={data['installmentOption'] ?? ""}/>
        ))
        : <></>}
        
        </>
    )
}


const CommonSection = ({ left = "", right = "",bold=false,microText="" }) => {
    return (
        <div style={{marginBottom:'10px'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', columnGap: '1rem' }}>
            <div style={{ width: '70%' }}>
                <Body size="large" bold={bold}>{left}</Body>
            </div>
            <div style={{ display:'flex',justifyContent:'flex-end' }}>
            <Body size="large" bold={bold}>{String(right).toLowerCase().includes('include') ? 'Included' : right}</Body>
            </div>
        </div>
        {microText ?
        <Micro color="#6F7171">{microText}</Micro>
        :<></>}
        </div>
    )
}


export default DueMonthlyPrint